import React, { Component } from 'react';
import utilFunction from '../../containers/function'
import strings from '../locales/';
import MapTravelChart from '../common/graphs/crossfilterGraphs/mapTravelChart';

const TravelAndEventsMap = (props) => (
  <div id="travel-and-events-map" className="dc-chart-parent">
    <MapTravelChart 
      id={"travel-and-events-map-component"} 
      crossfilerData={utilFunction.generateCrossfilter([])}
      dimension={{
        formatFunction:[],
        name:"alertName",
        originalName:"alertName",
        reduceFunction:{
          type: "DISCRETE_GROUP",
          typeof: "STRING",
          "parameters":{
            "categoriesParser":[],
            "categories": Object.keys((props.config)?props.config:{}).map(function(key,i){
              return [{"value":key,"operator":"=="}];
            }),
            "labels":Object.keys((props.config)?props.config:{}).map(function(key,i){
              return props.config[key].name;
            })
          }
        }
      }}
      metrics={[{
        config:{},
        filter: [],
        formatFunction: [],
        metric: "alertName",
        name: "alertName",
        reduceFunction: {type: "COUNT"},
        type: "COUNT"
      }]} 
      config={{
        "eventsCol":{"type":"alertName","path":"path"},
        "colors":["#F72944","#CD690B","#5299A1","#666ACC"]
      }}
      dashboardId={"driver_behavior"}
      direction={(props.data.gpsData)?{
        points: props.data.gpsData.map(function(item, i) {
            return [item.latitude,item.longitude];
        }),
        events: props.data.tripEventList.map(function(item, i) {
            return {alertName:item.alertName,path:item.gpsData.map(function(item, i) {
                return [item.latitude,item.longitude];
            })};
        })
      }:null}
      directionLoading={props.loadingMap}
      noLoading={props.noLoading}
    />
  </div>
);
  
export default TravelAndEventsMap;


// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/travelAndEventsMap.jsx